import { Camera, Smartphone, Download } from "lucide-react";
import { Separator } from "@/components/ui/separator";

export default function FotoRicordoPage() {
  return (
    <main
      data-testid="foto-ricordo-page"
      className="min-h-screen pt-20 pb-16 bg-warm-white"
    >
      <div className="max-w-3xl mx-auto px-6">
        {/* Header */}
        <div className="text-center py-10">
          <h1
            className="font-serif text-4xl sm:text-5xl mb-2"
            style={{ color: "#2C2C2C" }}
          >
            Foto Ricordo
          </h1>
          <div className="gold-line mb-4" />
          <p className="text-base" style={{ color: "#666666" }}>
            Aiutateci a catturare ogni momento speciale
          </p>
        </div>

        {/* Intro card */}
        <div
          className="bg-white rounded-sm p-8 mb-8 text-center"
          style={{ border: "1px solid rgba(197, 165, 114, 0.3)" }}
        >
          <Camera size={36} className="mx-auto mb-4" style={{ color: "#C5A572" }} />
          <p
            className="text-base leading-relaxed mb-2"
            style={{ color: "#2C2C2C" }}
          >
            Vogliamo rivivere questo giorno attraverso i vostri occhi!
            Scattate tutte le foto che volete e condividetele con noi
            tramite l'app gratuita <strong>WedShoots</strong>.
          </p>
          <p className="text-sm italic" style={{ color: "#666666" }}>
            Tutte le foto saranno raccolte in un unico album condiviso.
          </p>
        </div>

        {/* Album code */}
        <div
          data-testid="wedshoots-code-card"
          className="bg-white rounded-sm p-8 mb-8 text-center"
          style={{ border: "2px solid #C5A572" }}
        >
          <p
            className="text-xs uppercase tracking-[0.3em] mb-2"
            style={{ color: "#8B9A6B" }}
          >
            Codice Album
          </p>
          <p
            data-testid="wedshoots-code"
            className="font-serif text-3xl sm:text-4xl font-semibold tracking-wider mb-3"
            style={{ color: "#2C2C2C" }}
          >
            MARIANNA&MARCO
          </p>
          <p className="text-sm" style={{ color: "#666666" }}>
            Inserisci questo codice nell'app per accedere al nostro album
          </p>
        </div>

        {/* How it works */}
        <div
          className="bg-white rounded-sm p-8 mb-8"
          style={{ border: "1px solid rgba(197, 165, 114, 0.3)" }}
        >
          <h3
            className="font-serif text-xl text-center mb-6"
            style={{ color: "#2C2C2C" }}
          >
            Come funziona
          </h3>
          <div className="space-y-6">
            {/* Step 1 */}
            <div className="flex items-start gap-4">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "#8B9A6B" }}
              >
                <Download size={18} color="white" />
              </div>
              <div>
                <p className="font-medium text-base mb-1" style={{ color: "#2C2C2C" }}>
                  1. Scarica l'app WedShoots
                </p>
                <p className="text-sm" style={{ color: "#666666" }}>
                  Disponibile gratuitamente su App Store e Google Play
                </p>
              </div>
            </div>

            <Separator />

            {/* Step 2 */}
            <div className="flex items-start gap-4">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "#8B9A6B" }}
              >
                <Smartphone size={18} color="white" />
              </div>
              <div>
                <p className="font-medium text-base mb-1" style={{ color: "#2C2C2C" }}>
                  2. Inserisci il codice album
                </p>
                <p className="text-sm" style={{ color: "#666666" }}>
                  Apri l'app e inserisci il codice <strong>MARIANNA&MARCO</strong>
                </p>
              </div>
            </div>

            <Separator />

            {/* Step 3 */}
            <div className="flex items-start gap-4">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "#8B9A6B" }}
              >
                <Camera size={18} color="white" />
              </div>
              <div>
                <p className="font-medium text-base mb-1" style={{ color: "#2C2C2C" }}>
                  3. Scatta e condividi!
                </p>
                <p className="text-sm" style={{ color: "#666666" }}>
                  Il giorno del matrimonio carica tutte le foto che vuoi. Puoi anche aggiungere filtri e commenti!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Download buttons */}
        <div
          className="bg-white rounded-sm p-8 text-center"
          style={{ border: "1px solid rgba(197, 165, 114, 0.3)" }}
        >
          <h3
            className="font-serif text-xl mb-4"
            style={{ color: "#2C2C2C" }}
          >
            Scarica l'app
          </h3>
          <Separator className="mb-6" />
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://app.appsflyer.com/id660256196?pid=WP-iOS-IT&c=WP-IT-LANDINGS&s=it"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="wedshoots-ios"
              className="inline-block transition-transform hover:scale-105"
            >
              <img
                src="https://cdn1.matrimonio.com/assets/img/apps/apple-store-badge.svg"
                alt="Scarica su App Store"
                className="h-12"
              />
            </a>
            <a
              href="https://app.appsflyer.com/net.bodas.android.wedshoots?pid=WP-Android-IT&c=WP-IT-LANDINGS"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="wedshoots-android"
              className="inline-block transition-transform hover:scale-105"
            >
              <img
                src="https://cdn1.matrimonio.com/assets/img/apps/google-play-badge.svg"
                alt="Scarica su Google Play"
                className="h-12"
              />
            </a>
          </div>
          <p className="text-xs mt-4" style={{ color: "#666666" }}>
            L'app è completamente gratuita
          </p>
        </div>
      </div>
    </main>
  );
}
